class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    // Wholesale customers find the auto-open drawer disruptive when bulk-adding items
    if (document.body.dataset.wholesale === 'true') return;

    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }

    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.showAddedToast();
  }

  showAddedToast() {
    let toast = document.getElementById('dezlin-cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'dezlin-cart-toast';
      toast.style.cssText = [
        'position:fixed',
        'background:#22a06b',
        'color:#fff',
        'padding:9px 18px',
        'border-radius:8px',
        'font-family:Outfit,sans-serif',
        'font-size:13px',
        'font-weight:700',
        'letter-spacing:.2px',
        'z-index:9999',
        'opacity:0',
        'transition:opacity .2s ease,transform .2s ease',
        'pointer-events:none',
        'white-space:nowrap',
        'box-shadow:0 4px 14px rgba(0,0,0,.18)'
      ].join(';');
      document.body.appendChild(toast);
    }
    toast.textContent = '✓ Added to cart';

    // Anchor toast directly below the most recently clicked Add-to-Cart button.
    // Fallback: bottom-center of viewport if no button tracked (e.g. programmatic add).
    const btn = window.__dzLastAddBtn && document.body.contains(window.__dzLastAddBtn)
      ? window.__dzLastAddBtn
      : null;
    let startTransform;
    if (btn) {
      const r = btn.getBoundingClientRect();
      // Center horizontally on button, sit just below it. clamp to viewport edges.
      const toastWidth = 160; // approx; will recenter after paint via translateX(-50%)
      let cx = r.left + r.width / 2;
      // Clamp so toast doesn't clip viewport horizontally.
      cx = Math.max(toastWidth / 2 + 8, Math.min(window.innerWidth - toastWidth / 2 - 8, cx));
      const top = Math.min(window.innerHeight - 60, r.bottom + 8);
      toast.style.left = cx + 'px';
      toast.style.bottom = '';
      toast.style.top = top + 'px';
      startTransform = 'translateX(-50%) translateY(-6px)';
      toast.style.transform = startTransform;
    } else {
      toast.style.left = '50%';
      toast.style.top = '';
      toast.style.bottom = '84px';
      startTransform = 'translateX(-50%) translateY(12px)';
      toast.style.transform = startTransform;
    }

    requestAnimationFrame(() => {
      toast.style.opacity = '1';
      toast.style.transform = 'translateX(-50%) translateY(0)';
    });
    clearTimeout(this._toastTimeout);
    this._toastTimeout = setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transform = startTransform;
    }, 2200);
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);

// Track the most recently clicked Add-to-Cart-shaped button so the cart toast
// can anchor itself directly below the click target instead of floating at the
// bottom of the viewport. Capture-phase so we see the click before any handlers
// stop propagation.
(function dzTrackAddToCartButton() {
  const SELECTOR = [
    'add-to-cart button',
    'add-to-cart',
    'button[name="add"]',
    '.product-form__submit',
    '.dz-qa-add',
    '.dz-qa-plus',
    '.dz-qa-minus',
    '.wq-card-widget button[name="add"]',
    '.wq-card-widget [data-add-to-cart]',
    '[data-add-to-cart]'
  ].join(',');
  document.addEventListener('click', function (e) {
    const btn = e.target.closest && e.target.closest(SELECTOR);
    if (btn) window.__dzLastAddBtn = btn;
  }, true);
})();
